import React from 'react'
const date = new Date().getFullYear() - 15
const YearMinus15 = () => (
    <span>{date}</span>
)

export default YearMinus15